import { Component } from 'react';
import '../../../../styles/components/auth.scss';
import { withRouter } from '../../../../hoc/withRouter';
import { Mail } from 'lucide-react';
import i18n from '../../../../i18n';
class ForgotPasswordConfirmation extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="register-container">
        {/* Left Section */}
        <div className="login-left-section">
          <div className="auth-content">
            <div className="accent-line"></div>
            <h1 className="title">
              {i18n.t('login_banner_title')}
              <span className="highlight-l2">{i18n.t('login_banner_title_b')}</span>,{' '}
              {i18n.t('login_banner_title_c')}.
            </h1>
            <p className="subtitle-l2">{i18n.t('login_banner_subtitle')}</p>
          </div>
        </div>

        {/* Right Section */}
        <div className="login-right-section">
          <div className="login-card forgot-confirmation-card">
            <div className="email-icon-wrapper">
              <Mail className="email-icon-l2" />
            </div>

            <h3 className="welcome-title"> {i18n.t('check_your_email')}</h3>

            <p className="welcome-subtitle">{i18n.t('check_your_email_description')}</p>

            <p className="info-text">{i18n.t('please_check_your_inbox_and_spam_folder')}</p>

            <button
              className="button1 button1-gradient full-width"
              onClick={() => this.props.navigate('/login')}
            >
              {i18n.t('back_to_login')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ForgotPasswordConfirmation);
